var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AvailableTooltip } from '../../../../components/other/AvailableTooltip';
let AbfragerCycleEndGradePlace = class AbfragerCycleEndGradePlace extends React.PureComponent {
    render() {
        const { app } = this.props;
        return (React.createElement("div", { style: { flex: '0 1 auto', paddingLeft: 30, paddingTop: 10 } },
            React.createElement("div", { style: { whiteSpace: 'nowrap' } },
                React.createElement("h2", { className: "finish_grade", style: { display: 'inline-block' } },
                    "Note:",
                    React.createElement(AvailableTooltip, { placement: "top", title: React.createElement("span", null,
                            "der letzten ",
                            app.appGrade.numberOfAnswersGradeIsBasedOn,
                            " Antworten") },
                        React.createElement("span", { style: { marginLeft: 10, marginRight: 12, fontWeight: 'bold' }, className: "text-danger" }, app.appGrade.currentGradeString)),
                    React.createElement(AvailableTooltip, { placement: "right", title: React.createElement("span", null, "Durchschnittsnote aller Nutzer bei diesen Fragen") },
                        React.createElement("span", { className: "text-muted", style: { fontSize: 22, whiteSpace: 'nowrap', marginLeft: 10 } },
                            "\u00D8\u00A0",
                            React.createElement("span", null, app.appGrade.averageGrade))))),
            React.createElement("div", { style: { whiteSpace: 'nowrap' } },
                React.createElement("h2", { style: { display: 'inline-block', marginTop: 0 }, "data-toggle": "tooltip" },
                    "Platz:",
                    React.createElement("span", { className: "text-primary", style: { marginLeft: 10, marginRight: 10, fontWeight: 'bold' } }, app.appGrade.userPlace),
                    React.createElement("span", { style: { fontSize: 22, whiteSpace: 'nowrap' }, className: "text-muted" }, "von 100")))));
    }
};
AbfragerCycleEndGradePlace = __decorate([
    observer
], AbfragerCycleEndGradePlace);
export { AbfragerCycleEndGradePlace };
